var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.1,17.2c-0.3,0-0.5-0.1-0.7-0.3l-4.3-4.3V5.1c0-0.6,0.4-1,1-1s1,0.5,1,1v6.6l3.7,3.7c0.4,0.4,0.4,1,0,1.4 C16.6,17.1,16.4,17.2,16.1,17.2z M12.1,2.1c-5.5,0-10,4.5-10,10.1s4.5,10.1,10,10.1s10-4.5,10-10.1c0-2.7-1.1-5.2-2.9-7.1 C17.3,3.1,14.7,2.1,12.1,2.1z M12.1,24.3c-6.6,0-12-5.4-12-12.1s5.4-12.1,12-12.1s12,5.4,12,12.1c0,3.2-1.3,6.3-3.5,8.6 S15.3,24.3,12.1,24.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClock);
export default __webpack_public_path__ + "static/media/ico-clock.37aa9acaeb25042c0017310b499fa4ba.svg";
export { ForwardRef as ReactComponent };